import styled from "styled-components";

export const ContainerWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.primaryBackgroundLight};
  padding-top: 40px;
  padding-bottom: 80px;

  > h2 {
    text-align: center;
    margin-top: 40px;
    margin-bottom: 56px;

    color: ${({ theme }) => theme.colors.neutralsText};
    ${({ theme }) => theme.fontStyles.DesktopHeadlinesH3}
  }

  > div.commentsHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
    margin-top: 16px;

    > h3 {
      color: ${({ theme }) => theme.colors.neutralsText};
      ${({ theme }) => theme.fontStyles.DesktopHeadlinesH5}
    }
    > div {
      display: flex;
      align-items: center;
      gap: 4px;

      > span {
        color: ${({ theme }) => theme.colors.neutralsTextLight};
        ${({ theme }) => theme.fontStyles.InterfaceCopySmall}
      }

      > select {
        background: transparent;
        border: none;
        border-radius: 4px;
        padding: 4px 8px;
        color: ${({ theme }) => theme.colors.primaryText};
        ${({ theme }) => theme.fontStyles.InterfaceCopySmall}

        &:focus {
          outline: none;
          box-shadow: unset;
          border-color: unset;
        }
      }
    }
  }
`;

export const StyledDivider = styled.div`
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.colors.primaryRulerTint50};
`;

export const StyledCommentsWrapper = styled.div`
  width: 100%;
  // max-width: 1000px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: auto;
  // transition: max-height 0.5s;
  overflow: hidden;

  > div {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: stretch;

    ${({ theme }) => theme.media.onlyMobile`
      flex-direction: column;
      align-items: flex-start;
    `}
  }
`;
